export default __webpack_public_path__ + "static/media/up.24067fa0.mp3";